import clsx from "clsx";

interface ExternalLinkProps {
  href: string;
  children: string | React.ReactNode;
  classes?: string;
}

const ExternalLink = ({ href, children, classes = "" }: ExternalLinkProps) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={clsx("brand-link-with-underline b px-1", classes)}
    >
      {children}
    </a>
  );
};

export default ExternalLink;
